module.exports = [{
      plugin: require('/tmp/73f4e7f4/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
